import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/Loading";
import { FaLongArrowAltRight, FaRegEyeSlash } from "react-icons/fa";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { commonToast } from "../../helper/Toast";
import { useTranslation } from "react-i18next";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
const AdminLogin = () => {
    const { t } = useTranslation();
    const [isShow, setIsShow] = useState(false);
    const [loading] = useState(false);
    const navigate = useNavigate();

    const LoginSchema = Yup.object().shape({
        email: Yup.string()
            .email(t("validation.email_invalid"))
            .required(t("validation.email_required")),
        password: Yup.string().required(t("validation.passwordrequired")),
    });


    const handleLogin = (e) => {
        localStorage.setItem("zubrus_admin_data", "admin_token");
        localStorage.removeItem("zubrus_user_data");
        commonToast(t("loginmsg"), "success");
        navigate("/admin/auth/otp-verification");
    };

    return (
        <div className="flex-1 flex justify-center items-center">
            <div className=" max-w-5xl flex md:flex-col justify-start items-start gap-10 md:gap-0 mx-auto ">
                {/* <div className="w-1/2 md:w-full md:hidden">
                    <img
                        src="/assets/images/loginposterzubrus.png"
                        alt="Login Poster"
                        className="w-full h-[536px] "
                    />
                </div> */}
                <div className="max-w-xl md:max-w-full w-full bg-white my-6 rounded-2xl p-5">
                    <div className="flex justify-between items-center  mb-6">
                        <h3 className="subheading-text "> {t("login")}</h3>
                        <h3>{t("or")} <span className="underline lowercase"> {t("register")} </span></h3>
                    </div>

                    <Formik
                        initialValues={{
                            email: "",
                            password: "",
                        }}
                        validationSchema={LoginSchema}
                        onSubmit={(values) => {
                            handleLogin(values);
                        }}
                    >
                        {({ errors, touched }) => (
                            <Form>
                                <div>
                                    <label htmlFor="email" className="regular-text mb-2">{t("email")}</label>
                                    <Field
                                        name="email"
                                        type="text"
                                        placeholder={`${t("email")}`}
                                        className={`regular-text border h-[56px] w-full rounded-xl ps-5 shadow-inner outline-none placeholder:text-lightgray text-black ${errors.email && touched.email
                                            ? "border-red-500"
                                            : ""
                                            }`}
                                    />
                                    <ErrorMessage
                                        name="email"
                                        component="div"
                                        className="text-red-500 text-sm mt-1"
                                    />
                                </div>
                                <div className=" mt-6">
                                    <label htmlFor="email" className="regular-text mb-2">{t("password")}</label>
                                    <div className="relative flex items-center">
                                        <Field
                                            name="password"
                                            type={`${isShow ? "text" : "password"}`}
                                            placeholder={t("password")}
                                            className={`regular-text border h-[56px] w-full rounded-xl ps-5 shadow-inner outline-none placeholder:text-lightgray text-black ${errors.password && touched.password
                                                ? "border-red-500"
                                                : ""
                                                }`}
                                        />
                                        {isShow ? (
                                            <MdOutlineRemoveRedEye
                                                className="absolute cursor-pointer right-5 text-xl"
                                                onClick={() => setIsShow(!isShow)}
                                            />
                                        ) : (
                                            <FaRegEyeSlash
                                                className="absolute cursor-pointer right-5 text-xl"
                                                onClick={() => setIsShow(!isShow)}
                                            />
                                        )}
                                    </div>
                                </div>
                                <ErrorMessage
                                    name="password"
                                    component="div"
                                    className="text-red-500 text-sm mt-1"
                                />
                                <h4 className="underline mt-1">{t("forgotpass")}</h4>
                                <button
                                    type="submit"
                                    disabled={loading}
                                    className="medium-text primary-btn w-full mt-6 mx-auto "
                                >
                                    {loading ? <Loading /> : t("login")}
                                </button>
                            </Form>
                        )}
                    </Formik>
                    {/* 
                    <hr className="my-6" />
                    <div className="flex justify-between items-center ">
                        <span className="regular-text">{t("firstTime")}</span>
                        <Link
                            to={`/auth/signup`}
                            className="regular-text text-darkblue cursor-pointer flex items-center gap-2"
                        >
                            {t("signup")} <FaLongArrowAltRight />
                        </Link>
                    </div> */}
                </div>
                <div>
                    <div className=" w-full bg-white my-6 rounded-2xl p-5">
                        <h2 className="medium-text">{t("zubusstudent")}</h2>
                        <h3 className="medium-text !font-normal my-4">{t("dowenloadtext")}</h3>
                        <img src="/assets/images/playstore.png" alt="Play store" className="w-[123px] h-[48px]" srcset="" />
                    </div>
                    <div className=" w-full bg-white my-6 rounded-2xl p-5">
                        <h2 className="medium-text">{t("creatematerial")}</h2>
                        <h3 className="medium-text !font-normal mt-7 flex items-center gap-2 underline underline-offset-4">{t("fordeveloper")}  <FaLongArrowAltRight /></h3>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;
